module.exports = __webpack_public_path__ + "static/media/LK__Project.4a986bcf.svg";